module.exports = __webpack_public_path__ + "static/media/temperature.2a17ee39.jpg";